import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FtthService } from '../../../../../../../../../services/api/ftth/ftth.service';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Product } from '../../../../../../../../../models/interface/product/product';
import { generateExternalID, ProductSpecId } from '../../../../../../../../../models/order/order.model';
import * as moment from 'moment';
import { Subscription, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { OrderService } from 'src/app/services/api/orders/specific-order/order.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { ProductDepthLevelProductActionsComponent } from '../product-depth-level-product-actions.component';

@Component({
  selector: 'app-terminate',
  templateUrl: './terminate.component.html',
  styleUrls: ['./terminate.component.scss']
})
export class TerminateComponent implements OnInit, OnDestroy {

  item: Product;
  loading: boolean;

  private subscriptions = new Subscription();

  constructor(
    private ftthService: FtthService,
    private orderService: OrderService,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
    private dialogRef: MatDialogRef<ProductDepthLevelProductActionsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      item: Product;
      type: string;
    },
  ) {

  }

  ngOnInit() {
    this.loading = false;
    this.item = this.data.item;

    if (this.data.type !== 'product') {
      throw new Error('It must be a product');
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  terminate() {
    this.loading = true;
    this.ftthService.termination({
      'operador': this.item.origin,
      'idadministrativo': this.item.productCharValues.find(charValue => charValue.specId === "pc_ftth_service_id").value
    })
      .subscribe(
        (data) => {
          this.loading = false;
          if (data.resultado === 'OK') {
            this.dialogRef.close(true);
            this.notificationsService.showNotification(this.translateService.instant('TERMINATE_PRODUCT.success'), NotificationLevel.SUCCESS);
          }
          else {
            this.notificationsService.showNotification("ERROR (" + data.codResultado + "): " + data.descResultado, NotificationLevel.ERROR);
          }
        },
        error => {
          this.loading = false;
          this.notificationsService.showNotification("ERROR (" + error.data.codResultado + "): " + error.data.descResultado, NotificationLevel.ERROR);
        }
      )
  }

}
